export const MEDIUM_OF_INSTRUCTION_ENGLISH = "English";
export const MEDIUM_OF_INSTRUCTION_UKRAINE = "Ukraine";

export const MEDIUM_OF_INSTRUCTION_OPTIONS = [
  { value: MEDIUM_OF_INSTRUCTION_ENGLISH, label: MEDIUM_OF_INSTRUCTION_ENGLISH },
  { value: MEDIUM_OF_INSTRUCTION_UKRAINE, label: MEDIUM_OF_INSTRUCTION_UKRAINE },
] as const;

export const MEDIUM_OF_INSTRUCTION_LABELS = MEDIUM_OF_INSTRUCTION_OPTIONS.map(({ label }) => label);

const MEDIUM_OF_INSTRUCTION_ALIASES: Record<string, string> = {
  english: MEDIUM_OF_INSTRUCTION_ENGLISH,
  ukraine: MEDIUM_OF_INSTRUCTION_UKRAINE,
  ukrainian: MEDIUM_OF_INSTRUCTION_UKRAINE,
};

export const normalizeMediumOfInstructionValue = (value?: unknown): string => {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  if (MEDIUM_OF_INSTRUCTION_OPTIONS.some(({ label }) => label === trimmed)) {
    return trimmed;
  }

  return MEDIUM_OF_INSTRUCTION_ALIASES[trimmed.toLowerCase()] ?? trimmed;
};
